import { Else, If, Then } from 'react-if';
import cns from 'classnames';
import { StoreCategoryString } from '../../../../consts';
import { StoreGridProps, StoreItem } from '../../../../types/StoreTypes';
import StoreAppCard from './StoreAppCard';
import StoreAssetCard from './StoreAssetCard';
import S from './StoreGrid.module.scss';
const StoreGrid = ({
  items,
  type
}: StoreGridProps) => {
  const isAssetType = type === StoreCategoryString.map || type === StoreCategoryString.object;
  return <>
      <div className={cns(S.store_grid, {
      [S.store_grid_app]: !isAssetType
    })}>
        {items.map((item: StoreItem, index) => <If condition={isAssetType} key={item?.hashId || type + index.toString()}>
            <Then>
              <StoreAssetCard item={item} />
            </Then>
            <Else>
              <StoreAppCard item={item} />
            </Else>
          </If>)}
      </div>
      <div className={S.spacer} />
    </>;
};
export default StoreGrid;